import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  openNewPage,
  getHostName,
  API_GET_ORDERS,
} from "../modals/Constants";
import { getStorage, setStorage } from "../modals/Storage";
import general from "../css/General.module.css";
import screen from "../css/Screen.module.css";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";
import HeaderView from "../other-components/HeaderView/view";
import Button from "../UI/Button/ui";

function MyOrders() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [values, setConstants] = useState({
    totalRecords: 0,
    totalAmount: 0,
    currentPage: 1,
    totalPages: 0,
    pagination: false,
    dataLoaded: false,
    productList: [],
  });

  const getStatusMessage = (status) => {
    let message = "";
    if (status == 'active') {
      message = 'Confirmed';
    } else if (status == 'shipped') {
      message = 'Your item has been shipped';
    } else if (status == 'outfordelivery') {
      message = 'Your item is out for delivery';
    } else if (status == 'delivered') {
      message = 'Item delivered';
    }

    return message;
  }

  const updateUIItems = (data) => {
    let tempData = [];

    for (let i = 0; i < data.length; i++) {
      let id = data[i]["item_id"];
      let status = data[i]["item_status"];

      tempData.push(
        <Link key={id} className={screen.cartItem} to={`/myorder-details?q=${id}`}>
          <img
            className="w-100-p br-5"
            src={data[i]["item_media"]}
            alt="product-image"
          />

          <div className={screen.cartContentsView}>
            <h6
              className={screen.title}
            >
              {data[i]["item_name"]}
            </h6>

            <p className={[screen.sizeView, status === 'delivered' ? general.colorGreen : status === 'outfordelivery' && (general.colorPrimary)].join(" ")}>{getStatusMessage(data[i]["item_status"])}</p>

            <h6 className={screen.pricingView}>
              ₹{data[i]["item_price"]}
            </h6>


          </div>
        </Link >
      );
    }

    setConstants((previousState) => {
      return { ...previousState, productList: tempData };
    });
  };

  function loadRecords() {
    async function requestAPI(url, formData) {
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'authorization': `Bearer ${getStorage("accountSecret")}`,
          },
          body: JSON.stringify(formData),
        });

        const data = await res.json();
        setLoading(false);

        if ((data.status_code = "success")) {

          setConstants((previousState) => {
            return {
              ...previousState,
              totalRecords: data.total_records,
              totalAmount: data.total_amount,
              currentPage: data.current_page,
              totalPages: data.total_pages,
              pagination: data.pagination,
              dataLoaded: true,
            };
          });

          updateUIItems(data.data);
        }
      } catch (error) {
        setLoading(false);
      }
    }

    setLoading(true);
    const formData = {
      ACCOUNT_ID: getStorage("accountID"),
      ACCOUNT_ID: getStorage("accountID"),
      PAGE: values.currentPage,
    };

    requestAPI(API_GET_ORDERS, formData);
  }

  const paginate = (command) => {
    let newPage = 0;
    if (command == "plus") {
      if (values.currentPage < 100 && values.pagination) {
        newPage = values.currentPage + 1;
      }
    } else {
      if (values.currentPage > 1) {
        newPage = values.currentPage - 1;
      }
    }

    if (newPage > 0) {
      setConstants((previousState) => {
        return {
          ...previousState,
          currentPage: newPage,
        };
      });
    }
  }

  useEffect(() => {
    loadRecords();
  }, [values.currentPage]);

  return (
    <div className={[general.appView]}>
      <LoadingDialog isOpen={loading} />

      <div className={[general.appChildView]}>
        <HeaderView screen={"myorders"} />

        <div className={general.appLocationViews}>
          <p>My Orders</p>
        </div>

        <div className={[general.appContentsView]}>
          {values.totalRecords > 0 ?
            <div className={[screen.cartView, general.mgB100px].join(" ")}>

              <div className={[screen.contentsView]}>
                {values.productList}

                <div className={[general.viewCenter, general.pd10px, general.mgT25px].join(" ")}>
                  <div className={general.paginationView}>
                    <button className={values.currentPage === 1 ? general.disable : null} onClick={() => paginate("minus")}><span className="material-symbols-outlined icon-size-xs">arrow_back_ios_new</span></button>
                    <p>{values.currentPage}/{values.totalPages}</p>
                    <button className={!values.pagination ? general.disable : null} onClick={() => paginate("plus")}><span className="material-symbols-outlined icon-size-xs">arrow_forward_ios</span></button>
                  </div>
                </div>
              </div>

              <div className={screen.overview}>
                <p className={screen.title}>Order totals</p>

                <br></br>
                <div className={screen.listView}>
                  <p>Total orders</p>
                  <p>{values.totalRecords}</p>
                </div>

                <div className={screen.listView}>
                  <p>Total order amount</p>
                  <p className={screen.subTitle}>₹{values.totalAmount}</p>
                </div>
              </div>
            </div>
            : values.totalRecords <= 0 && values.dataLoaded &&
            (<div
              className={screen.emptyContentsView}
            >
              <img src={require("../media/icons/shopping_bag_icon.png")} />
              <p>No orders to display</p>

              <br></br>
              <Button
                text="Continue Shopping"
                appearance={3}
                rounded={true}
                action={{ onClick: () => navigate("/", { replace: false }) }}
              />
            </div>)}
        </div>
      </div>
    </div>
  );
}

export default MyOrders;
